import { Column } from 'primereact/column'
import { DataTable } from 'primereact/datatable'
import React, { useEffect, useState } from 'react'
import { withRouter } from 'react-router-dom'
import { tableCellCentered } from '../../../../../assets/js/styles'
import {
  Btn,
  CustomMultiSelect,
  CustomPanel,
  InputText,
  PageHeader,
  ThreeDots,
  CustomDataTableHeader,
} from '../../../../../components'
import useEmailState, { EmailAction, EMAIL_FIELDS_NAME } from './EmailsState'
import { connect } from 'react-redux'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../../store/actions/system.actions'

export default connect()(withRouter(Emails))

function Emails({ history, dispatch }) {
  const { lista_nome, lista_id } = history.location.state

  const {
    emailData,
    listaEmails,
    listaTps,
    loading,
    erro,
    onMenuItemClicked,
    onFieldChange,
    resetErro,
    onBtnSalvarClick,
    onBtnLimparClick,
  } = useEmailState(lista_id)
  const [globalFilter, setGlobalFilter] = useState('')

  useEffect(() => {
    erro && dispatch(showMessageBox(null, erro)) && resetErro()
  }, [erro])

  useEffect(() => {
    if (loading === EmailAction.LOADING_CARREGANDO_EMAILS) {
      dispatch(showLoadingBox('Carregando os Emails . . .', 'Aguarde :'))
    } else if (loading === EmailAction.LOADING_APAGANDO_EMAIL) {
      dispatch(showLoadingBox('Apagando o Email . . .', 'Aguarde :'))
    } else {
      dispatch(hideLoadingBox())
    }
  }, [loading])

  // Render
  return (
    <>
      <PageHeader>
        Emails :&nbsp; <strong>{lista_nome}</strong>
      </PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel showBtnNovo={false} onVoltar={history.goBack}>
          <div className="p-grid">
            <div className="p-col-3">
              <InputText
                label="Nome:"
                value={emailData.nome}
                onChange={value => onFieldChange(EMAIL_FIELDS_NAME.NOME, value)}
              />
            </div>
            <div className="p-col-3">
              <InputText
                label="Email:"
                value={emailData.email}
                onChange={value => onFieldChange(EMAIL_FIELDS_NAME.EMAIL, value)}
              />
            </div>
            <div className="p-col-3">
              <CustomMultiSelect
                label={'Selecione os Operadores:'}
                filter={true}
                onChange={value => onFieldChange(EMAIL_FIELDS_NAME.TPS, value)}
                value={emailData.tpsSelecionados}
                options={listaTps}
              />
            </div>
            <div className="p-col-3" style={{ paddingTop: 43 }}>
              <Btn
                onClick={onBtnSalvarClick}
                isLoading={loading === EmailAction.LOADING_SALVANDO_EMAIL}
              >
                Salvar
              </Btn>
              <div style={{ display: 'inline-block', marginLeft: 16 }}>
                <Btn onClick={onBtnLimparClick}>Limpar</Btn>
              </div>
            </div>
            <div className="p-col-12">
              <DataTable
                value={listaEmails}
                emptyMessage="Não existe Emails associados"
                globalFilter={globalFilter}
                header={<CustomDataTableHeader onChange={value => setGlobalFilter(value)} />}
                rows={10}
                paginator
              >
                <Column field="id" header="Código" style={tableCellCentered(70)} />
                <Column field="name" header="Nome" />
                <Column field="email" header="Email" />
                <Column field="tpNomes" header="Operadores" />
                <Column
                  header="Menu"
                  style={tableCellCentered(70)}
                  body={email => (
                    <ThreeDots
                      items={['Editar', 'Excluir']}
                      onClick={item => onMenuItemClicked(item, email)}
                    />
                  )}
                  bodyStyle={tableCellCentered()}
                />
              </DataTable>
            </div>
          </div>
        </CustomPanel>
      </div>
    </>
  )
}
